import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParamsContext } from "../../../../../context/juno/ParamsContext";
import ImageUpload from "./ImageUpload";

type ImageProps = {
  type: "primary" | "secondary" | "tertiary" | "quaternary";
};

const Image: React.FC<ImageProps> = ({ type }) => {
  const { t } = useTranslation();
  const { aiEngine } = useParamsContext();

  const title = () => {
    if (aiEngine === "GPTImage1") {
      if (type === "primary") return t("juno.input.image") + " 1";
      if (type === "secondary") return t("juno.input.image") + " 2";
      if (type === "tertiary") return t("juno.input.image") + " 3";
      if (type === "quaternary") return t("juno.input.image") + " 4";
    }

    switch (aiEngine) {
      case "FluxPuLID":
        return t("juno.input.imageFace");
      case "KolorsVTO":
        return type === "primary" ? t("juno.input.imageHuman") : t("juno.input.imageVTO");
      case "BriaBackgroundReplace":
        return type === "primary" ? t("juno.input.imageMain") : t("juno.input.imageBackground");
      case "BriaProductShot":
        return type === "primary" ? t("juno.input.imageProduct") : t("juno.input.imageBackground");
      case "IdeogramV3":
      case "IdeogramV3Remix":
      case "IdeogramV3ReplaceBackground":
      case "IdeogramV3Edit":
        return type === "primary" ? t("juno.input.image") : t("juno.input.imageStyle");
      default:
        return t("juno.input.image");
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }} gap={1} mb={1}>
        <Typography variant={"body2"}>{title()}</Typography>
      </Box>
      <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
        <ImageUpload type={type} />
      </Box>
    </Box>
  );
};
export default Image;
